<div class="container-seat-map" *ngIf="seatMap">
  <div class="column-left">
    <app-seats-map-wings [isLarge]="seatMapIsLargeSeatMap(seatMap)"
    [seatMapSeat]="seatMapSeat" [seatMap]="seatMap"></app-seats-map-wings>
  </div>
  <div class="column-seats">
    <ng-container *ngFor="let cabin of seatMap?.Cabins">
      <ng-container *ngFor="let rowType of cabin.Rows">
        <ng-container [ngSwitch]="rowType.Type">

          <div class="container-lettes" *ngSwitchCase="rowDataTypes.Letters">
            <div class="box-letter" [class.space]="!letter.Letter" *ngFor="let letter of rowType.Data">
              <span *ngIf="letter.Letter">{{letter.Letter}}</span>
            </div>
          </div>

          <div class="container-title" *ngSwitchCase="rowDataTypes.Title">
            <div class="line-left">
              <div class="line"></div>
            </div>
            <div class="title-column">
              <span>{{titleCabinClass(rowType.Data)|transloco}}</span>
            </div>
            <div class="line-right">
              <div class="line"></div>
            </div>
          </div>

          <div class="container-exit" *ngSwitchCase="rowDataTypes.Exit">
            <div class="exit">
              {{'SEAT_MAP_MODULE.EXIT'|transloco}}
            </div>
            <div class="exit">
              {{'SEAT_MAP_MODULE.EXIT'|transloco}}
            </div>
          </div>

          <ng-container *ngSwitchCase="rowDataTypes.Seat">
            <div class="container-seats" *ngFor="let rowData of rowType.Data">
              <ng-container *ngFor="let seat of rowData.Seats">
                <div #boxSeat class="box-seat" [class.occupied]="seat.Inoperative||seat.Occupied"
                  [class.select-error]="seat.ErrorSelected" [class.selected]="seat.Selected||seat.Preview"
                  [class.large]="seatMapIsLarge(rowData.Seats.length)"
                  *ngIf="!seatPositionSpaceAisle(seat.Location);else boxSeatSpace"
                  (click)="selectBoxSeat(boxSeat,rowData.RowNumber+seat.Number,seat,seatMap.Passengers,seatMap.Seats)">
                  <ng-container *ngIf="!seat.NotSeat">
                    <div class="left"></div>
                    <div class="center">
                      <div class="top" [class.large]="seatMapIsLarge(rowData.Seats.length)"
                        [class.occupied]="seat.Inoperative||seat.Occupied" [class.select-error]="seat.ErrorSelected">
                        <ng-container *ngIf="seat.Preview;else seatSelected">
                          <span class="name">{{rowData.RowNumber}}{{seat.Number}}</span>
                        </ng-container>
                        <ng-template #seatSelected>
                          <span class="name"
                            *ngIf="seat.Selected">{{filterPassengerSelected(rowData.RowNumber+seat.Number,seatMap.Seats)|uppercase}}</span>
                        </ng-template>
                      </div>
                      <div class="bottom" [class.large]="seatMapIsLarge(rowData.Seats.length)"></div>
                    </div>
                    <div class="right"></div>
                  </ng-container>
                </div>
                <ng-template #boxSeatSpace>
                  <div class="box-space-aisle">
                    <span>
                      {{rowData.RowNumber}}
                    </span>
                  </div>
                </ng-template>
              </ng-container>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>

    <div class="container-select-user" *ngIf="activeSelectUser">
      <div class="triangle-select" [class.arrow-bottom]="positionTopListSelectUser" [style.top.px]="topArrowSelectUser"
        [style.left.px]="leftSelectUser"></div>
      <div class="list-select-user" [class.arrow-bottom]="positionTopListSelectUser"
        [style.left.px]="leftListSelectUser" [style.top.px]="topSelectUser">
        <div class="box-item" *ngFor="let passenger of filterPassengersSelected(seatMap.Seats,false)">
          <label [attr.for]="'radio'+passenger.FirstName">{{passenger.FirstName | dateFormat|titlecase}}
            {{passenger.Surname | dateFormat|titlecase}}</label>
          <input [id]="'radio'+passenger.FirstName" [checked]="isSelectSeat(passenger,(seatMapSeat))"
            (click)="selectSeatPassenger(passenger)" type="radio">
        </div>
        <ng-container *ngIf="filterPassengersSelected(seatMap.Seats,true) as passengers">
          <span class="subtitle" *ngIf="passengers.length>0">Reasignar a:</span>
          <div class="box-item reassigned" *ngFor="let passenger of passengers">
            <label [attr.for]="'radio'+passenger.FirstName">{{passenger.FirstName | dateFormat|titlecase}}
              {{passenger.Surname | dateFormat|titlecase}}</label>
            <input [id]="'radio'+passenger.FirstName" [checked]="isSelectSeat(passenger,seatMapSeat)"
              (click)="selectSeatPassenger(passenger)" type="radio">
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="column-right">
    <app-seats-map-wings [orientationRight]="true" [isLarge]="seatMapIsLargeSeatMap(seatMap)"
    [seatMapSeat]="seatMapSeat" [seatMap]="seatMap"></app-seats-map-wings>
  </div>
</div>